import { useMemo } from 'react';

import { useApaAgentsQuery } from 'hooks/queries/apa';

import { useActiveClusters } from './useActiveClusters';
import { ClusterWithApaOperator } from '../types';

export const useClustersWithApa = () => {
  const { clusters } = useActiveClusters();
  const { apaAgents, isLoading, error, refetch } = useApaAgentsQuery();

  const clustersData = useMemo((): ClusterWithApaOperator[] => {
    return clusters.map((cluster) => {
      const agent = apaAgents?.find((agent) => agent.clusterId === cluster.id);
      return {
        ...cluster,
        agent,
      };
    });
  }, [apaAgents, clusters]);

  const apaClusters = useMemo(() => {
    if (isLoading || !clustersData.length) {
      return [];
    }

    return clustersData.filter((cluster) => !!cluster.agent);
  }, [clustersData, isLoading]);

  return {
    clusters: clustersData,
    apaClusters,
    hasClustersWithApa: apaClusters.length > 0,
    isLoading,
    error,
    refetch,
  };
};
